import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box } from "@mui/material";

import { BaseLabel, colors } from "components";

import { IMenuListMconf } from "./interface";
import {
  Container,
  Header,
  Right,
  Left,
  EmptyMessage,
  MenuListMconfDropdown,
} from "./styles";


export const MenuListMconf: React.FC<IMenuListMconf> = ({
  id,
  title,
  list,
  emptyMessage,
  open,
  titlePaddingLeft,
  titlePaddingRight,
  backgroudColorHeader,
  disabled = false,
}) => {
  const [show, setShow] = useState(title.toLowerCase() === open || false);
  const statusRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!show && open === title.toLowerCase()) {
      setShow(true);
    }

    if (show && !(open === title.toLowerCase())) {
      setShow(false);
    }
  }, [open, title]);

  useEffect(() => {
    const handleDocumentClick = (e: any) => {
      if (statusRef.current && !statusRef.current.contains(e.target)) {
        setShow(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleShow = () => {
    if (!disabled) {
      setShow((prev) => !prev);
    }
  };

  const dropdown = (
    <MenuListMconfDropdown>
      {list && list.length > 0 ? (
        list.map((item, index) => <div key={index}>{item}</div>)
      ) : (
        <EmptyMessage>
          <BaseLabel
            fontSize="14px"
            fontStyle="italic"
            color={colors.neutral_gray_40}
            marginLeft="0px"
          >
            {emptyMessage}
          </BaseLabel>
        </EmptyMessage>
      )}
    </MenuListMconfDropdown>
  );

  return (
    <>
      <Container ref={statusRef} id={id} data-testid={"id"}>
        <Header onClick={handleShow} backgroudColor={backgroudColorHeader}>
          <Left>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                left: "0",
              }}
            >
              <BaseLabel
                fontWeight="600"
                fontSize="14px"
                marginRight={titlePaddingRight ?? "0px"}
                marginLeft={titlePaddingLeft ?? "0px"}
                color="white"
                width="140px"
              >
                {title}
              </BaseLabel>
            </Box>
          </Left>
          <Right>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                right: "0",
                cursor: "pointer", 
              }}
              onClick={(e) => {
                e.stopPropagation(); 
                handleShow();
              }}
            >
              {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </Box>
          </Right>
        </Header>

      </Container>
      {show && createPortal(dropdown, document.body)}
    </>
  );
};
